/**
 * Created by zzy on 2019/8/8.
 */
import VideoDiagnosisStatistics from './VideoDiagnosisStatistics.vue'
export default VideoDiagnosisStatistics



// WEBPACK FOOTER //
// ./src/views/statistics/videoDiagnosisStatistics/index.js